import React from "react";
import EditProfile from "./edit-profile";
import Calendar from "./calendar";
import SettingsMembership from "./settings-membership";
import SettingsOurMission from "./settings-our-mission";
import Notifications from "./notifications";
import FeatureFlags from "./feature-flags";
import ManageDevices from "./manage-devices";
import HowItWorks from "./how-it-works";
import DesktopSettingsSection from "desktop/settings/DesktopSettingsSection";
import {
  LearnerSettings,
  LearnerBiometrics,
} from "apps/user/learner/api/types";
import { useParams } from "react-router-dom";

import styles from "./styles.module.scss";

interface SettingsNavigationDetailProps {
  settings: LearnerSettings;
  hasHealthData: LearnerBiometrics["hasHealthData"];
}

const SettingsNavigationDetail = ({
  settings,
  hasHealthData,
}: SettingsNavigationDetailProps) => {
  const { subnav } = useParams();
  const calendar = <Calendar calendar={settings.calendar} />;
  const DetailView = {
    notifications: <Notifications notifications={settings.notifications} />,
    featureflags: <FeatureFlags />,
    desktop: <DesktopSettingsSection />,
    calendar,
    // Retired Smart Calendar return URLs, kept so old bookmarks still land here.
    "smart-calendar-error": calendar,
    "smart-calendar-successful": calendar,
    membership: <SettingsMembership membership={settings.membership} />,
    ourmission: <SettingsOurMission mission={settings.ourMission} />,
    managedevices: settings.biometrics && (
      <ManageDevices
        provider={settings.biometrics.providers}
        hasHealthData={hasHealthData}
      />
    ),
    "how-it-works": settings.biometrics && (
      <HowItWorks howItWorks={settings.biometrics.howItWorks} />
    ),
  };

  return (
    <div className={styles["settings-navigation-detail"]}>
      {subnav ? (
        DetailView[subnav]
      ) : (
        <EditProfile fields={settings.profile.fields} />
      )}
    </div>
  );
};

export default SettingsNavigationDetail;
